import React from 'react';

import Colors from 'common/colors/constants';
import Button from 'common/inputs/Button';
import ModernModal from 'common/modals/ModernModal';

import 'css/components/modals/_ModernMarkSpamModal.scss';

type Props = {
  onClose(): void;
  onConfirm(): void;
  title?: string;
  type?: 'post' | 'comment';
};

const MaxCharLimit = 64;
const RedBackground = Colors.red90;
const Headers = {
  comment: 'Mark comment as spam',
  post: 'Mark post as spam',
};

const ModernMarkSpamModal = ({ onClose, onConfirm, title, type }: Props) => {
  const titleContainer = title
    ? title.length > MaxCharLimit
      ? `"${title.slice(0, MaxCharLimit).trim()}..."`
      : `"${title}"`
    : `this ${type}`;
  const header = type ? Headers[type] : 'Mark spam';

  return (
    <ModernModal
      overlayClassName="markSpamModalPortal"
      onClose={onClose}
      header={header}
      sections={[
        <>
          <div>
            <p className="spamTitle">Are you sure you'd like to mark {titleContainer} as spam?</p>
            <div className="spamConsequences">
              <p>The following action will:</p>
              <ul>
                <li>Delete posts, comments, and votes from this user.</li>
                <li>Ban them from creating future posts, comments, and votes.</li>
              </ul>
            </div>
            <p className="spamWarning">This action is irreversible.</p>
          </div>
        </>,
      ]}
      footer={
        <>
          <Button buttonType="ghostButton" onTap={onClose} value="Cancel" />
          <Button
            buttonStyle={{ background: RedBackground }}
            buttonType="cannyButton"
            onTap={onConfirm}
            value="Mark as spam"
          />
        </>
      }
    />
  );
};

export default ModernMarkSpamModal;
